import useOnboardingPortalStore from "../OnboardingPortal.Store";
import Modal from "../../../components/modal/Modal";
import {
    EonUiIcon,
    EonUiInput,
    EonUiButton,
} from "@eon-ui/eon-ui-components-react";
import { useEffect, useState } from "react";
import { useJwtToken } from "@me8eon/react_authentication";
import { useTranslation } from "@me8eon/translation";
import ActivityLogScreen from "./ActivityLogScreen";
import OnboardingPortalAppIcon from "../components/OnboardingPortalAppIcon";
import OnboardingPortalLoader from "../components/OnboardingPortalLoader";
import { getCompanyDisplayList } from "../OnboardingPortal.utils";

const ReviewAppsModal = () => {
    const t = useTranslation();
    const jwt = useJwtToken();
    const {
        showReviewApp,
        reviewAppData,
        resetReviewApp,
        handleReviewApp,
        isSubmittingReviewApp,
    } = useOnboardingPortalStore();
    const [reviewerNotes, setReviewerNotes] = useState<string>("");

    useEffect(() => {
        setReviewerNotes("");
    }, [showReviewApp]);

    const handleEmailAppOwner = () => {
        const subject = `Regarding Onboarding your app (${reviewAppData?.title}) in MyHelp`;
        const body = `Dear App Owner,\n\nThis is regarding the onboarding of your application:\n\nApp ID: ${reviewAppData?.appId}\nApp Title: ${reviewAppData?.title}\n\nPlease review and provide necessary information.\n\nBest regards`;
        const mailtoLink = `mailto:${reviewAppData?.owner}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.location.href = mailtoLink;
    };

    return (
        <>
            <Modal
                toggleModal={showReviewApp}
                closeModal={resetReviewApp}
                isCloseIcon={false}
                closeOnBackdrop={false}
                modalClass="review-modal"
            >
                <div
                    style={{
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                        padding: 20,
                    }}
                >
                    {isSubmittingReviewApp && <OnboardingPortalLoader />}
                    <div className="onboarding-portal--header">
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: 12,
                            }}
                        >
                            <h1 className="onboarding-portal--header--heading">
                                {t(
                                    `onboardingPortal.modalLabel.reviewAppTitle`
                                )}
                            </h1>
                            <div style={{ marginLeft: "auto" }}>
                                <ActivityLogScreen
                                    key={`app-activity-log-${reviewAppData?.id}`}
                                    entityType="app"
                                    entityData={reviewAppData}
                                />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: "8px",
                                    fontSize: "18px",
                                    color: "#1E1E1E",
                                    fontWeight: "medium",
                                    // marginLeft: "auto",
                                    cursor: "pointer",
                                }}
                                onClick={handleEmailAppOwner}
                            >
                                <EonUiIcon
                                    name="notification"
                                    scheme="red500"
                                />
                                <span>
                                    {t(`onboardingPortal.modalLabel.mail`)}{" "}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 12,
                            alignItems: "center",
                        }}
                    >
                        <OnboardingPortalAppIcon
                            icon={reviewAppData?.icon}
                            iconUrl={reviewAppData?.iconDataUrl}
                        />
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {reviewAppData?.title}
                            </span>
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {reviewAppData?.subTitle}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                                marginLeft: "auto",
                                textAlign: "right",
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(`onboardingPortal.modalLabel.owner`)}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {reviewAppData?.owner}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                                marginLeft: "auto",
                                textAlign: "right",
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(`onboardingPortal.modalLabel.createdOn`)}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {new Date(
                                    reviewAppData?.createdAt || ""
                                ).toLocaleString()}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                                marginLeft: "auto",
                                textAlign: "right",
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(`onboardingPortal.modalLabel.status`)}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                                className={`status ${reviewAppData?.status}`}
                            >
                                {t(
                                    `onboardingPortal.statusLabel.${reviewAppData?.status}`
                                )}
                            </span>
                        </div>
                    </div>
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: 12,
                            alignItems: "center",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(`onboardingPortal.modalLabel.url`)}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {reviewAppData?.url}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(`onboardingPortal.modalLabel.tooltip`)}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {reviewAppData?.tooltip}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(
                                    `onboardingPortal.modalLabel.companiesAllowed`
                                )}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {getCompanyDisplayList(
                                    reviewAppData?.companiesAllowed
                                ).join(", ")}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(
                                    `onboardingPortal.modalLabel.companiesRestricted`
                                )}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {getCompanyDisplayList(
                                    reviewAppData?.companiesRestricted
                                ).join(", ")}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(`onboardingPortal.modalLabel.keywords`)}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {reviewAppData?.keywords.join(", ")}
                            </span>
                        </div>
                    </div>
                    <div>
                        <EonUiInput
                            size="small"
                            style={{
                                marginTop: 8,
                                marginBottom: 8,
                            }}
                            placeholder="Reviewer Notes"
                            value={reviewerNotes || ""}
                            onValueChanged={(e) =>
                                setReviewerNotes(e.target.value)
                            }
                            textarea
                            rows={2}
                            label="Comments"
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 8,
                            alignItems: "center",
                        }}
                    >
                        <EonUiButton
                            rank="primary"
                            size="small"
                            text={t("onboardingPortal.approveBtn")}
                            disabled={!reviewerNotes}
                            onClick={() => {
                                handleReviewApp(
                                    jwt,
                                    reviewAppData?.id || "",
                                    "approved",
                                    reviewerNotes || ""
                                );
                            }}
                        />
                        <EonUiButton
                            rank="secondary"
                            size="small"
                            text={t("onboardingPortal.rejectBtn")}
                            disabled={!reviewerNotes}
                            onClick={() => {
                                handleReviewApp(
                                    jwt,
                                    reviewAppData?.id || "",
                                    "rejected",
                                    reviewerNotes || ""
                                );
                            }}
                        />
                        <div
                            style={{
                                fontSize: "18px",
                                color: "#1E1E1E",
                                fontWeight: "medium",
                                marginLeft: "auto",
                                cursor: "pointer",
                            }}
                            onClick={() => resetReviewApp()}
                        >
                            <span>Cancel</span>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ReviewAppsModal;
